import {useTheme} from "@mui/material";
import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate, useParams} from "react-router-dom";
import DeliverySiteOnboardingRequestFormScreen from "../../components/forms/DeliverySiteOnboardingRequestFormScreen";
import FilledButton from "../../components/buttons/FilledButton";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import {styles} from "../orders/create_order/CreateOrderStyles";
import DeliverySiteOnboardingFeature from "./DeliverySiteOnboardingFeature";


function DeliverySiteOnboardingCreateScreen() {
    const application = useApplication();
    const theme = useTheme();
    const navigator = useNavigate();
    const {id} = useParams();
    const feature = useNavigatorFeature(
        () => new DeliverySiteOnboardingFeature(application, navigator, id, null),
        navigator,
        [id]
    );
    const style = styles(theme);

    const isFeatureReady = () => {
        return feature && feature.loaded;
    };

    const createForm = () => {
        return isFeatureReady() && (
            <div>
                <DeliverySiteOnboardingRequestFormScreen
                    deliverySite={feature.form}
                    jurisdictionsOptions={feature.jurisdictionsFieldOptions()}
                    zonesOptions={feature.zonesFieldOptions()}
                    frequenciesOptions={feature.frequenciesFieldOptions()}
                    zonesFrequencyForDeliverySite={(deliverySiteOnboardingRequestForm) =>
                        feature.chosenZoneFrequency(deliverySiteOnboardingRequestForm)}
                />
                <div style={style.buttonsContainer}>
                    <FilledButton disabled={!feature.isFormValid}
                                  onClick={() => feature.createDeliverySiteOnboarding()}>
                        Confirmar
                    </FilledButton>
                </div>
            </div>
        );
    };

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady()} renderContent={() => createForm()}/>
    );
}

export default observer(DeliverySiteOnboardingCreateScreen);
